// extracted by mini-css-extract-plugin
export default {"main":"Main_main__rpV-y","mainCard":"Main_mainCard__hIKae"};